import { Button, Icon } from '@chakra-ui/react'
import { RiCustomerService2Fill } from 'react-icons/ri'
import { Link } from 'react-router-dom'
import { useMediaQuery } from '@chakra-ui/react'

export function MeusChamadosButton() {
  const [isLargerThan1366] = useMediaQuery('(max-width: 1366px)')

  return (
    <Button
      mb={2}
      as={Link}
      to="/meus-chamados"
      variant="ghost"
      colorScheme="blue"
      size="sm"
      leftIcon={<Icon as={RiCustomerService2Fill} color="#37F091" />}
      _hover={{ color: '#37F091' }}
      _focus={{ boxShadow: 'none' }}
      padding="0 8px"
      color="white"
      borderRadius="0"
      bg="#313E44"
      {...(isLargerThan1366 && { fontSize: '13px' })}
    >
      Meus Chamados
    </Button>
  )
}
